import { Box, ButtonBase, Typography, makeStyles } from "@material-ui/core";
import * as React from "react";

import { Chevron } from "@/components/Chevron";
import { textStyles } from "@/designTokens";
import theme from "@/theme";

const useStyles = makeStyles(() => ({
  row: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "16px 0",
    textAlign: "left",
    justifyContent: "space-between",
    ...textStyles["SP/Body/Large"],
    "&:focus-visible": { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 2 },
  },
  label: { flex: "1 1 0", minWidth: 0, overflowWrap: "anywhere", font: "inherit" },
  right: { display: "flex", alignItems: "center", gap: 8, minWidth: 0, maxWidth: "62%" },
  value: { textAlign: "right", font: "inherit", overflowWrap: "anywhere" },
  since: { ...textStyles["SP/Body/Small"], color: theme.palette.text.secondary, display: "block" },
  chevron: { width: 6, height: 10, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  current: { backgroundColor: theme.palette.semantic["surface/base"], borderRadius: 8, padding: 16, marginBottom: 32 },
  amount: { ...textStyles["SP/Heading/H2"], fontSize: 24 },
}));

export const PropertyEditHistoryRow: React.FC<{
  label: string;
  value?: string;
  since?: string;
  onClick?: () => void;
}> = ({ label, value, since, onClick }) => {
  const classes = useStyles();
  const contents = (
    <>
      <Typography component="span" className={classes.label}>
        {label}
      </Typography>
      <Box className={classes.right}>
        <Typography component="span" className={classes.value}>
          {value || "未登録"}
          {since && <span className={classes.since}>{since}</span>}
        </Typography>
        {onClick && (
          <span className={classes.chevron}>
            <Chevron />
          </span>
        )}
      </Box>
    </>
  );
  return onClick ? (
    <ButtonBase className={classes.row} onClick={onClick}>
      {contents}
    </ButtonBase>
  ) : (
    <Box className={classes.row}>{contents}</Box>
  );
};

export const PropertyEditCurrentValue: React.FC<{ value: React.ReactNode; since?: string; label?: string }> = ({
  value,
  since,
  label = "現在の金額",
}) => {
  const classes = useStyles();
  return (
    <Box className={classes.current}>
      <Typography className={classes.since}>{label}</Typography>
      <Typography className={classes.amount}>{value}</Typography>
      {since && <Typography className={classes.since}>{since}から</Typography>}
    </Box>
  );
};
